import { hasRole, isAdminNotConsultant, isConsultantOrHolding, isHolding } from "@/js/http/auth.js";
import AdminOrderList from "@/components/order/AdminOrderList.vue";
import ConsultantOrderList from "@/components/order/ConsultantOrderList.vue";
import SourcingList from "@/components/sourcing/SourcingList.vue";
import CreditNoteListAdmin from "@/components/creditnote/CreditNoteListAdmin.vue";
import CreditNoteListHolding from "@/components/creditnote/CreditNoteListHolding.vue";
import AdminInboundDeliveryList from "@/components/inbound/AdminInboundDeliveryList.vue";
import FactoringProviderList from "@/components/factoringprovider/FactoringProviderList.vue";
import AdminOrdersSubMenusLinks from "@/components/menu/sub-menus/orders/AdminOrdersSubMenusLinks.vue";
import ConsultantOrdersSubMenusLinks from "@/components/menu/sub-menus/orders/ConsultantOrdersSubMenuLinks.vue";
export default {
  name: "Orders",
  components: {
    AdminOrderList: AdminOrderList,
    CreditNoteListAdmin: CreditNoteListAdmin,
    SourcingList: SourcingList,
    CreditNoteListHolding: CreditNoteListHolding,
    ConsultantOrderList: ConsultantOrderList,
    AdminInboundDeliveryList: AdminInboundDeliveryList,
    FactoringProviderList: FactoringProviderList,
    AdminOrdersSubMenusLinks: AdminOrdersSubMenusLinks,
    ConsultantOrdersSubMenusLinks: ConsultantOrdersSubMenusLinks
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      selectedTab: null,
      tabs: {
        orders: "orders",
        sourcing: "sourcing",
        creditNote: "creditNote",
        inboundDeliveries: "inboundDeliveries",
        factoringProviders: "factoringProviders"
      },
      searchCriterias: {
        label: "",
        status: null,
        paging: {
          limits: 24,
          currentPage: 0,
          askedPage: 0
        }
      },
      canAccessSourcing: false,
      canManageCreditNote: false,
      canManageFactoringProviders: false,
      canManageDeliveries: false
    };
  },
  created: function created() {
    if (typeof this.$route.params != "undefined" && typeof this.$route.params.searchCriterias != "undefined") {
      this.searchCriterias = this.$route.params.searchCriterias;
    }
    this.selectedTab = this.$route.query.tab || this.tabs.orders;
    this.canAccessSourcing = hasRole(process.env.VUE_APP_ROLES_ACCESS_SOURCING);
    this.canManageCreditNote = isAdminNotConsultant(this.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_ORDER);
    this.canManageFactoringProviders = isAdminNotConsultant(this.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_FACTORING);
    this.canManageDeliveries = hasRole(process.env.VUE_APP_ROLES_MANAGE_DELIVERIES);
  },
  methods: {
    tabChanged: function tabChanged(tab) {
      this.selectedTab = tab;
    },
    isAdminNotConsultant: isAdminNotConsultant,
    isConsultantOrHolding: isConsultantOrHolding,
    isHolding: isHolding
  }
};